<img src="/assets/images/control-page/full_large-error-noData-compare.svg">
<app-text class="is-family-semiBold text-14 text-grey-80 is-justify-center" [text]="'common-app.__WEBAPP_SELECT_DATA_GRAPH' | AsyncLang | async"></app-text>